const DEFAULT_MAX_LOGS = 50

class FlowMonitor {
  constructor({ maxLogs = DEFAULT_MAX_LOGS } = {}) {
    this.maxLogs = maxLogs
    this.logs = []
  }

  log(step, data = {}) {
    this.logs.push({ step, data, ts: Date.now() })
    if (this.logs.length > this.maxLogs) {
      this.logs.splice(0, this.logs.length - this.maxLogs)
    }
  }

  dump() {
    return this.logs.map((entry) => ({ ...entry }))
  }

  reset() {
    this.logs = []
  }
}

export default FlowMonitor
